<template>
  <CCard class="mb-3">
    <CCardHeader>Distribucion del tiempo</CCardHeader>
    <CCardBody>
      <CRow>
        <CCol md="6">
          <CCard class="dist-kpi-card">
            <CCardBody>
              <div class="small text-muted">KPI: Tiempo hasta lectura</div>
              <div class="h4 mb-1">{{ minutes(reading.median) }}</div>
              <div class="small text-muted">Mediana | Muestra: {{ number(reading.sample_size) }}</div>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol md="6">
          <CCard class="dist-kpi-card">
            <CCardBody>
              <div class="small text-muted">KPI: Tiempo hasta respuesta</div>
              <div class="h4 mb-1">{{ minutes(response.median) }}</div>
              <div class="small text-muted">Mediana | Muestra: {{ number(response.sample_size) }}</div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <CRow class="mt-2">
        <CCol md="6">
          <div class="dist-box">
            <div class="font-weight-bold mb-2">Detalle lectura</div>
            <div class="small"><strong>Promedio:</strong> {{ minutes(reading.average) }}</div>
            <div class="small"><strong>P25:</strong> {{ minutes(reading.p25) }}</div>
            <div class="small"><strong>P75:</strong> {{ minutes(reading.p75) }}</div>
            <div class="small"><strong>P90:</strong> {{ minutes(reading.p90) }}</div>
          </div>
        </CCol>
        <CCol md="6">
          <div class="dist-box">
            <div class="font-weight-bold mb-2">Detalle respuesta</div>
            <div class="small"><strong>Promedio:</strong> {{ minutes(response.average) }}</div>
            <div class="small"><strong>P25:</strong> {{ minutes(response.p25) }}</div>
            <div class="small"><strong>P75:</strong> {{ minutes(response.p75) }}</div>
            <div class="small"><strong>P90:</strong> {{ minutes(response.p90) }}</div>
          </div>
        </CCol>
      </CRow>

      <div class="small text-muted mt-3 dist-help">
        <div><strong>Mediana:</strong> valor central de los tiempos.</div>
        <div><strong>Promedio:</strong> suma total de tiempos entre el numero de mensajes.</div>
        <div><strong>P25:</strong> el 25% de los mensajes tuvo un tiempo menor o igual a ese valor.</div>
        <div><strong>P75:</strong> el 75% de los mensajes tuvo un tiempo menor o igual a ese valor.</div>
        <div><strong>P90:</strong> el 90% de los mensajes tuvo un tiempo menor o igual a ese valor.</div>
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
export default {
  name: 'ReadingTimeDistributionCard',
  props: {
    distribution: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    reading() {
      return this.distribution && this.distribution.time_to_read_minutes
        ? this.distribution.time_to_read_minutes
        : {}
    },
    response() {
      return this.distribution && this.distribution.time_to_response_minutes
        ? this.distribution.time_to_response_minutes
        : {}
    },
  },
  methods: {
    number(value) {
      return Number(value || 0).toLocaleString('es-MX')
    },
    minutes(value) {
      if (value === null || value === undefined) {
        return 'N/D'
      }
      return `${Number(value).toFixed(1)} min`
    },
  },
}
</script>

<style scoped>
.dist-box {
  border: 1px solid #ece7d8;
  border-radius: 8px;
  padding: 12px;
  background: #fcfaf5;
}

.dist-kpi-card {
  border: 1px solid #e6e0d1;
  background: #fcfaf5;
}

.dist-grid {
  display: grid;
  gap: 6px;
}

.dist-help {
  line-height: 1.45;
}
</style>
